<template>
	<v-main>
		<v-navigation-drawer fixed clipped permanent style="padding: 64px 0px 0px 0px;" width="300">
			<v-list>
				<v-list-group v-for="item in items" :key="item.title"
					v-model="item.active"
					:prepend-icon="item.icon"
					no-action
				>
					<template v-slot:activator>
						<v-list-item-content>
							<v-list-item-title v-text="item.title"></v-list-item-title>
						</v-list-item-content>
					</template>

					<v-list-item v-for="child in item.items" :key="child.title" :to="child.to">
						<v-list-item-icon>
							<v-icon v-text="child.icon"></v-icon>
						</v-list-item-icon>
						<v-list-item-content>
							<v-list-item-title v-text="child.title"></v-list-item-title>
						</v-list-item-content>
					</v-list-item>
				</v-list-group>
			</v-list>
			<!-- <v-card flat>
				<v-card-text>
					
				</v-card-text>
			</v-card> -->
			<!-- <template v-slot:append>
				<v-card-actions class="px-4">
					<v-spacer></v-spacer>
					<v-btn text color="primary" @click="onClear">{{ $vuetify.lang.t('$vuetify.clear') }}</v-btn>
					<v-btn color="primary" @click="onOK">{{ $vuetify.lang.t('$vuetify.ok') }}</v-btn>
				</v-card-actions>
			</template> -->
		</v-navigation-drawer>

		<v-navigation-drawer fixed clipped permanent right floating
			mini-variant
			mini-variant-width="56"
			style="padding: 64px 0px 0px 0px;"
        >
			
        </v-navigation-drawer>

		<v-container style="padding: 0px 256px 0px 256px;">
			<h1 class="v-heading text-h3 text-sm-h3 mb-4">
				<!-- <a href="#text-and-typography" class="text-decoration-none text-right text-md-left"> # </a> -->
				{{ title }}
			</h1>
			<p>{{ subtitle }}</p>
			<p>URL: https://developers.ortica-systems.com</p>
			<ol>
				<li>Визначання ціни
					<p>POST /vehicle/estimate/averageprice/showroom?apikey=<ваш ключ></p>
					<p>Заголовки:</p>
					<p>Заголовки:</p>
					<p>Приклад запиту</p>
					<code>

						curl --location 'https://developers.ortica-systems.com/vehicle/estimate/averageprice/statistic?apikey=71bcb79512f4462159d44419d07d372e' \
--header 'Cookie: PH_HPXY_CHECK=s1; PHPSESSID=403cacc236dd4e8102363c8c7404fe98' \
--header 'Content-Type: text/plain' \
--data '{
    "type": {
        "code": "exploration"
    },
    "number": null,
    "vin": null,
    "mileage": [
        1,
        1000
    ],
    "engineVolume": [
        1,
        5000
    ],
    "use": {},
    "category": {
        "id": "13",
        "name": "Легкові автомобілі",
        "riaCode": 1
    },
    "brand": {
        "id": "2",
        "name": "BMW",
        "riaCode": 9
    },
    "model": {
        "id": "190",
        "name": "X5",
        "brand": {
            "id": "2",
            "name": "BMW"
        },
        "riaCode": 96
    },
    "year": 2021,
    "generation": {
        "id": "103",
        "name": "G05",
        "description": null,
        "yearFrom": 2018,
        "yearTo": 0,
        "eng": "g05"
    },
    "modification": {
        "id": "837",
        "code": null,
        "name": "40d MHEV Steptronic (340 к.с.) xDrive",
        "description": null
    }
}'
					</code>

					<pre>
						<code>
{
	"tab": "number",
	"type": {
		"code": "exploration"
	},
	"number": null,
	"vin": null,
	"mileage": [],
	"engineVolume": [],
	"use": {},
	"bargain": 1,
	"category": {
		"id": "13",
		"code": "CAR",
		"name": "Легкові автомобілі",
	},
	"brand": {
		"id": "1",
		"name": "Audi",
	},
	"model": {
		"id": "37",
		"name": "Q8",
	},
	"generation": null,
	"modification": null,
	"yearProd": 2025,
	"driver": {
		"id": "1",
		"code": null,
		"name": "Повний",
		"description": null
	},
	"fuel": {
		"id": "2",
		"code": null,
		"name": "Дизель",
		"description": null
	}
}</code>
					</pre>
				</li>

				<!-- GET https://developers.ortica-systems.com/doc?apikey=71bcb79512f4462159d44419d07d372e -->

			</ol>
		</v-container>
		<!-- <v-overlay :value="loading">
			<v-progress-circular indeterminate size="64" ></v-progress-circular>
		</v-overlay> -->
		<!-- <v-snackbar v-model="snackbar.visible" :color="snackbar.color">
			{{ snackbar.text }}
			<template v-slot:action="{ attrs }">
			<v-btn icon v-bind="attrs" @click="snackbar.visible = false" >
				<v-icon>mdi-close</v-icon>
			</v-btn>
			</template>
		</v-snackbar> -->

		<!-- <z-pdf ref="pdf" :item="item"></z-pdf> -->
	</v-main>
</template>

<script>
import { mapGetters } from 'vuex'
//import VueMarkdown from 'markdown-it'
//import VueMarkdown from 'vue-markdown-render'
import zPdf from '@/views/pdf/VehicleAveragePriceAI'
import downloadExcel from "vue-json-excel";

export default {
	name: 'HelpVehicleAveragePriceShowroom',
	components: {
		//VueMarkdown, 
		zPdf,
	},
	data: () => ({
		title: 'Ціна нового авто в салонах',
		subtitle: 'Визначення ціни нового авто за даними з салонів',
		icon: 'mdi-calculator',
	}),

	props: {
		doc:   	{ type: String, default: 'Help' },
	},

	computed: {
		...mapGetters('Help', [ 'items' ]),
	},

	methods: {
		onPDF () {
			//this.$refs.pdf.generate()
		},
	},
}
</script>